<template>
  <form 
    v-if="!requestSuccess" 
    class="animated fadeIn" 
    @submit.prevent="submit()">
    <h1>User Registration</h1>
    <hr >
    <div class="form-group mb-3">
      <label for="newPassword">Username</label>

      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text"><i class="icon-envelope"/></span>
        </div>
        <input 
          id="email" 
          v-model="user.userName" 
          type="email" 
          class="form-control" 
          placeholder="Enter your email" 
          required>
      </div>
    </div>
    <div class="form-group mb-3">
      <label for="oldPassword">Full Name</label>

      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text"><i class="icon-user"/></span>
        </div>
        <input 
          id="fullName" 
          v-model="user.fullName" 
          type="text" 
          class="form-control" 
          placeholder="Full Name" 
          required>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col">
        <small 
          v-show="isError" 
          class="text-danger">{{ msg.errorMsg }}</small>
      </div>
    </div>
    <div class="row">
      <div 
        v-show="!requestSuccess" 
        class="col-6">
        <button 
          :disabled="isFetching" 
          type="submit" 
          class="btn btn-primary px-4">Register</button>
      </div>
      <div class="col-6 text-right">
        <router-link :to="{ name: 'Login', query: urlQuery }">Back to Login</router-link>
      </div>
    </div>
  </form>
  <div 
    v-else-if="requestSuccess" 
    class="success-img text-center text-success px-3 py-3 my-4">
    <i class="fa fa-check-circle-o fa-4x" />
    <h5 class="mt-2">{{ msg.successMsg }}</h5>
  </div>
</template>
<script>
import auth from '@/services/auth.service'

export default {
  name: 'Registration',
  data () {
    return {
      user: Object,
      msg: Object,
      requestSuccess: false,
      isError: false,
      isFetching: false
    }
  },
  computed: {
    urlQuery () {
      let params = this.$route.query
      return params
    }
  },
  methods: {
    submit () {
      this.isFetching = true
      auth.register(this.user)
      .then(
        resp => {
          this.isFetching = false
          this.requestSuccess = true
          this.msg.successMsg = resp.data.msgContent
        },
        err => {
          this.isFetching = false
          this.isError = true
          this.msg.errorMsg = err.response.data.msgContent
        }
      )
    }
  },
}
</script>
